import React, {PureComponent} from 'react';
import {Button, Col, Container, Row, Card, CardBody, Badge} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress';
import {fetchSalesItemDataIfNeeded} from '../../redux/actions/SalesItemActions';
import {customer_insert, customer_update, fetchCustomeraDataIfNeeded} from '../../redux/actions/CustomersActions';
import {ButtonToolbar} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import ReactQueryParams from 'react-query-params';
import * as TextManager from "../../modules/languages/TextManager";
import RadioButtonField from "../../components/RadioButton";
import Select from "../../components/Select";
import * as http from '../../modules/http';
import {Redirect} from 'react-router-dom';
import 'react-credit-cards/lib/styles.scss';
import Cards from 'react-credit-cards';
import NumberFormat from 'react-number-format';
import * as environment from "../../modules/environment";
import * as common from "../../modules/common";
import {getCreditCardType} from "../../modules/common";
import equal from 'deep-equal'
import Modal from '../../components/Modal'
import {checkId} from "../../modules/common";


class InternetSalesItem extends ReactQueryParams {


    constructor(props) {
        super(props);
        this.state = {
            warning: '',
            error: false,
            saved: false,
            success: false,
            cardFocus: "",
            formFields: {
                customerName: (props.customer && props.customer.name) ? props.customer.name : "",
                customerId: (props.customer && props.customer.customerId) ? props.customer.customerId : "",
                id: (props.customer && props.customer.passport) ? props.customer.passport : "",
                address: (props.customer && props.customer.address) ? props.customer.address : "",
                providerId: (props.customer && props.customer.providerId) ? props.customer.providerId : "",
                providerName: (props.customer && props.customer.providerName) ? props.customer.providerName : "",
                storeId: (props.customer && props.customer.storeId) ? props.customer.storeId : 0,
                storeName: (props.customer && props.customer.storeName) ? props.customer.storeName : "",
                numOfLines: (props.customer && props.customer.numOfLines) ? props.customer.numOfLines : 0,
                lines: (props.customer && props.customer.lines) ? props.customer.lines : [
                    {
                        deal: {
                            text: "",
                            amount: "0"
                        },
                        customerNumber: "",
                        simNumber: "",
                        status: 0,
                        secondStatus: 0,
                        notes: '',
                        question: 0
                    }
                ],
                status: (props.customer && props.customer.status) ? props.customer.status : 0,
                secondStatus: (props.customer && props.customer.secondStatus) ? props.customer.secondStatus : 0,
                paymentMethod: (props.customer && props.customer.paymentMethod) ? props.customer.paymentMethod : "credit",
                paymentDetails: (props.customer && props.customer.paymentDetails) ? props.customer.paymentDetails : {
                    cardType: "unknown",
                    cardNumber: "",
                    validationDate: "",
                    cvv: "",
                    bank: "",
                    bankAccountBranch: "",
                    bankAccountNumber: ""
                },
                day: (props.customer && props.customer.day) ? props.customer.day : "",
                commentsStore: (props.customer && props.customer.commentsStore) ? props.customer.commentsStore : "",
                commentsManager: (props.customer && props.customer.commentsManager) ? props.customer.commentsManager : "",
                manageDay: (props.customer && props.customer.manageDay) ? props.customer.manageDay : "",
                updateDay: (props.customer && props.customer.updateDay) ? props.customer.updateDay : "",
            }
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchSalesItemDataIfNeeded(this.props.match.params.id ? this.props.match.params.id :
            this.props.customer.providerId ? this.props.customer.providerId : 0)).then(response => {

            if (response) {
                this.setState({
                    formFields: {
                        ...this.state.formFields, lines: this.state.formFields.lines
                            .map((l, index) => {
                                //console.log(l.deal.length > 0 ? 'true' : 'false');
                                return {
                                    customerNumber: l.customerNumber,
                                    simNumber: l.simNumber,
                                    deal: (l.deal && Object.getOwnPropertyNames(l.deal).length > 0) ? l.deal : this.props.dealsList[0],
                                    status: l.status,
                                    secondStatus: l.secondStatus,
                                    notes: l.notes,
                                    question: l.question === undefined ? 0 : l.question
                                }
                            })
                    }
                }, () => {
                });
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (!equal(this.props, nextProps)) {
            let formFields = this.state.formFields;
            formFields.paymentDetails = (nextProps.customer && nextProps.customer.paymentDetails) ? nextProps.customer.paymentDetails : {
                cardType: "unknown",
                cardNumber: "",
                validationDate: "",
                cvv: "",
                bank: "",
                bankAccountBranch: "",
                bankAccountNumber: ""
            };
            this.setState({formFields: formFields})
        }
    }

    formFieldValueChanged = (type, value) => {
        let updatedFormFields = {...this.state.formFields};

        if (type === 'commentsManager') {
            if (this.props.userData.data.isManager || this.props.userData.data.isAdmin) {
                updatedFormFields[type] = value;
                this.setState({formFields: updatedFormFields});
            }
        }
        else if (type === 'commentsStore') {
            if (!this.props.userData.data.isManager && !this.props.userData.data.isAdmin) {
                updatedFormFields[type] = value;
                this.setState({formFields: updatedFormFields});
            }
        }
        else {
            updatedFormFields[type] = value;
            this.setState({formFields: updatedFormFields});
        }
    };

    cardFocusChanged = (type) => {
        let cardFocus = "";
        switch (type) {
            case "cardNumber":
                cardFocus = "number";
                break;
            case "validationDate":
                cardFocus = "expiry";
                break;
            case "cvv":
                cardFocus = "cvc";
                break;
            default:
                cardFocus = "";
                break;
        }
        this.setState({cardFocus: cardFocus});
    };

    paymentDetailsChanged = (type, value) => {
        let updatedPaymentDetails = {...this.state.formFields.paymentDetails};
        updatedPaymentDetails[type] = value;
        let updatedPaymentFormFields = {...this.state.formFields, paymentDetails: updatedPaymentDetails};
        this.setState({formFields: updatedPaymentFormFields});
    };


    // label: "HOT"
    // value: 7

    getProviderName = () => {
        if (this.props.location.state && this.props.location.state.name) {
            // it comes from path
            return this.props.location.state.name;
        }
        else {
            //it comes from props
            if (this.props.customer && this.props.customer.provider) {
                return this.props.customer.provider;
            }
        }
    };

    getProviderId = () => {
        if (this.props.location.state && this.props.location.state.id) {
            // it comes from path
            return this.props.location.state.id;
        }
        else {
            //it comes from props

            if (this.props.customer && this.props.customer.providerId) {
                //return this.props.utilsData.data.providers.find(e => e.label === this.props.customer.provider).value;
                return this.props.customer.providerId;
            }

        }
    };

    saveCustomer = () => {

        let isNew = this.props.location.state && this.props.location.state.name;


        if (!this.state.formFields.customerName || this.state.formFields.customerName === '') {
            this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectName});
            return;
        }
        /*if (!this.props.formFields.product_id || this.props.formFields.product_id === 0) {
            this.setState({warning: TextManager.getCurrentTextResource().Text.productIsMandatoryField});        deal
            return;
        }*/
        if (!this.state.formFields.id || this.state.formFields.id === '') {
            this.setState({warning: TextManager.getCurrentTextResource().Text.passportMandatoryField});
            return;
        }

        if (!this.state.formFields.address || this.state.formFields.address === '') {
            this.setState({warning: TextManager.getCurrentTextResource().Text.addressIsMandatoryField});
            return;
        }
        if (this.state.formFields.lines.length === 0) {
            this.setState({warning: TextManager.getCurrentTextResource().Text.lineIsMandatoryField});
            return;
        }
        else {
            let shouldReurn = false;
            this.state.formFields.lines.forEach((line) => {
                if (!line.deal.text || line.deal.text.length === 0 || !line.deal.amount || line.deal.amount.length === 0 ||
                    !line.simNumber || line.simNumber.length === 0) {

                    this.setState({warning: TextManager.getCurrentTextResource().Text.dealFieldsCantBeEmpty});
                    shouldReurn = true;
                }
            });

            if (shouldReurn) {
                return
            }
        }

        if (this.state.formFields.paymentMethod === "credit") {
            if (!this.state.formFields.paymentDetails) {
                return;
            }
            /*if (!this.state.formFields.paymentDetails.cardType || this.state.formFields.paymentDetails.cardType === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                return;
            }*/
            if (!this.state.formFields.paymentDetails.cardNumber || this.state.formFields.paymentDetails.cardNumber === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                return;
            }
            /* if (!this.state.formFields.paymentDetails.validationDate || this.state.formFields.paymentDetails.validationDate.length !== 5) {
                 this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                 return;
             }*/
            /*if (!this.state.formFields.paymentDetails.cvv || this.state.formFields.paymentDetails.cvv.length < 3) {
                this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                return;
            }*/
        }

        if (this.state.formFields.paymentMethod === "bank") {
            if (!this.state.formFields.paymentDetails) {
                return;
            }
            if (!this.state.formFields.paymentDetails.bank || this.state.formFields.paymentDetails.bank === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                return;
            }
            if (!this.state.formFields.paymentDetails.bankAccountBranch || this.state.formFields.paymentDetails.bankAccountBranch === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                return;
            }
            if (!this.state.formFields.paymentDetails.bankAccountNumber || this.state.formFields.paymentDetails.bankAccountNumber === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                return;
            }
        }

        if(!checkId(this.state.formFields.id)) {
            this.setState({warning: 'מספר תז לא תקין'});
            return;
        }


        this.setState({warning: '', saving: true, error: false});
        //let providerName = this.getProviderName();
        let providerId = this.getProviderId();

        let customerData = {
            id: isNew ? 0 : this.props.customer.id,
            name: this.state.formFields.customerName,
            customerId: this.state.formFields.customerId,
            passport: this.state.formFields.id,
            address: this.state.formFields.address,
            providerId: isNew ? providerId : this.state.formFields.providerId,
            providerName: isNew ? '' : this.state.formFields.providerName,
            storeId: isNew ? this.props.userData.data.id : this.state.formFields.storeId,
            storeName: this.state.formFields.storeName,
            numOfLines: this.state.formFields.lines.length,
            lines: this.state.formFields.lines,
            status: isNew ? 1 : this.state.formFields.status,
            secondStatus: isNew ? 0 : this.state.formFields.secondStatus,
            paymentMethod: this.state.formFields.paymentMethod,
            paymentDetails: this.state.formFields.paymentDetails,
            day: isNew ? '' : this.state.formFields.day,
            commentsStore: this.state.formFields.commentsStore,
            commentsManager: this.state.formFields.commentsManager,
            manageDay: isNew ? '' : this.state.formFields.manageDay,
            updateDay: isNew ? '' : this.state.formFields.updateDay

        };

        let requestUrl = 'customers/new';

        if (!isNew) {
            requestUrl = 'customers/update';
        }
        console.log(customerData);

        http.postToServer(
            requestUrl,
            customerData,
            (response) => {
                if (!isNew) {
                    this.setState({saving: false, error: false, saved: false});
                    this.props.dispatch(customer_update(response.data));
                    this.props.onClose();
                }
                else {
                    this.props.dispatch(customer_insert(response.data));
                    this.setState({saving: false, error: false, success: true});
                }
            },
            (response) => {
                this.setState({saving: false, error: true});
            }
        );
    };

    linesChanged = (change, index, field, value) => {

        const formFieldsNewState = {...this.state.formFields};

        switch (change) {
            case 'delete':
                const newDeleteLinesState = [...formFieldsNewState.lines].filter((line, i) => i !== index);
                formFieldsNewState.lines = newDeleteLinesState;
                break;
            case 'update':
                const newUpdateLinesState = [...formFieldsNewState.lines];
                newUpdateLinesState[index][field] = value;
                formFieldsNewState.lines = newUpdateLinesState;
                break;
            case 'add':
                const newAddLinesState = [...this.state.formFields.lines, {
                    customerNumber: "",
                    simNumber: "",
                    deal: this.props.dealsList[0],
                    status: 0,
                    secondStatus: 0,
                    notes: '',
                    question: 0
                }];
                formFieldsNewState.lines = newAddLinesState;
                break;
            default:
                break;
        }

        this.setState({formFields: formFieldsNewState});

    };

    dealChanged = (index, value) => {
        const newDeal = {amount: value.amount, text: value.value};

        const newLinesState = [...this.state.formFields.lines];
        newLinesState[index].deal = newDeal;

        const formFieldsNewState = {...this.state.formFields, lines: newLinesState};

        this.setState({formFields: formFieldsNewState});

    };

    addLine = () => {
        this.linesChanged("add");
    };


    limit = (val, max) => {
        if (val.length === 1 && val[0] > max[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val > max) {
                val = max;
            }
        }

        return val;
    };

    cardExpiry = (val) => {
        let month = this.limit(val.substring(0, 2), '12');
        let year = val.substring(2, 4);

        return month + (year.length ? '/' + year : '');
    };

    changeLineStatus = (type, index) => {
        if (this.props.userData.data.isManager || this.props.userData.data.isAdmin) {
            const tmp = [...this.state.formFields.lines];

            tmp[index][type] = tmp[index][type] === 0 ? 1 : 0;

            const formFieldsNewState = {...this.state.formFields, lines: tmp};

            this.setState({formFields: formFieldsNewState});
        }
    };

    render() {
        document.querySelectorAll(".rccs__number").forEach(function (anchor) {
            anchor.innerHTML = anchor.innerHTML.replace(/•/g, ' ');
        });

        //console.log(this.getProviderId())

        let logoUrl = environment.getServerBasePath() + '/providers/download?providerID=' + this.getProviderId();


        let isNew = this.props.location.state && this.props.location.state.name;


        if (this.state.saved === true) {
            if (isNew) {
                return <Redirect to='/sales'/>
            }
        }
        let totalPrice = 0;
        this.state.formFields.lines.forEach((line) => {
            totalPrice += parseInt(line.deal.amount);
        });


        let transferQuestionOptions = [
            {
                value: 0,
                label: "לא"
            },
            {
                value: 1,
                label: "כן"
            }
        ];

        let transferQuestionOptionsOnAdd = [
            {
                value: 0,
                label: "חדש"
            },
            {
                value: 1,
                label: "ניוד"
            }
        ];

        return (
            <Container className='sales'>
                {this.state.success &&
                <Modal color='success' title={TextManager.getCurrentTextResource().Text.wellDone} noCancel
                       message={TextManager.getCurrentTextResource().Text.dealSucceeded}
                       approve={() => this.setState({saved: true})}/>
                }
                <style>
                    {`
                        .card-body {
                        box-shadow: 0 10px 30px 1px rgba(0, 0, 0, 0.06);
                        }
                    `}
                </style>

                {(this.props.status === 'request' || this.state.saving) &&
                <Row>
                    <LoadingProgress/>
                </Row>}

                {(this.props.status === 'error' || this.state.error) &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>}

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>}

                {this.props.status === 'success' &&

                <Row>

                    {isNew && <Col md={12} lg={12}>

                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                <h3>{this.props.location.state.name}</h3>

                                <div className='topbar__right'>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>}

                    <Col md={12} lg={12}>

                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                {this.state.warning !== '' &&
                                <Row>
                                    <Alert color='warning' className='alert--bordered' icon>
                                        <p><span
                                            className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                        </p>
                                    </Alert>
                                </Row>}
                                <form className="form">

                                    {!isNew && <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'>{TextManager.getCurrentTextResource().Customers.day}</label>
                                        <div className='form__form-group-field'>
                                            <input
                                                value={this.state.formFields.day}
                                                dir={"auto"}
                                                name="amount"
                                                type="text"
                                                disabled={true}
                                                style={{
                                                    backgroundColor: '#DCDCDC',
                                                    width: '140px'
                                                }}/>
                                        </div>
                                    </div>}

                                    <div className="form__form-group">
                                        <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                            <Row style={{flexDirection: "row-reverse"}}>

                                                <Col md={2} xs={4}>
                                                    <label className="form__form-group-label">
                                                        {TextManager.getCurrentTextResource().Sales.salesItem.customerNumberId}
                                                    </label>
                                                    <div className="form__form-group-field">
                                                        <input name="customerName"
                                                               style={{backgroundColor: '#F0F8FF'}}
                                                               value={this.state.formFields.customerId}
                                                               dir={"auto"}
                                                               onChange={(event) =>
                                                                   this.formFieldValueChanged('customerId', event.target.value)}
                                                        />
                                                    </div>
                                                </Col>


                                                <Col md={2} xs={4}>
                                                    <label className="form__form-group-label">
                                                        {TextManager.getCurrentTextResource().Sales.salesItem.customerName}
                                                    </label>
                                                    <div className="form__form-group-field">
                                                        <input name="customerName"
                                                               style={{backgroundColor: '#F0F8FF'}}
                                                               value={this.state.formFields.customerName}
                                                               type="text"
                                                               dir={"auto"}
                                                               onChange={(event) =>
                                                                   this.formFieldValueChanged('customerName', event.target.value)}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={2} xs={4}>
                                                    <label
                                                        className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.id}</label>
                                                    <div className="form__form-group-field">
                                                        <NumberFormat
                                                            format="#########"
                                                            style={{backgroundColor: '#F0F8FF'}}
                                                            value={this.state.formFields.id}
                                                            name="id"
                                                            type="text"
                                                            onChange={(event) =>
                                                                this.formFieldValueChanged('id', event.target.value)}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={2} xs={4}>
                                                    <label
                                                        className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.address}</label>
                                                    <div className="form__form-group-field">
                                                        <input
                                                            dir={"auto"}
                                                            style={{backgroundColor: '#F0F8FF'}}
                                                            value={this.state.formFields.address}
                                                            name="address"
                                                            type="text"
                                                            onChange={(event) =>
                                                                this.formFieldValueChanged('address', event.target.value)}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={3} xs={4}>
                                                    <span style={{display: "inline-block", height: 50}}></span>
                                                    <img src={logoUrl} style={{
                                                        maxWidth: '190px',
                                                        maxHeight: '190px',
                                                        objectFit: 'contain'
                                                    }}/>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>

                                    <div className="form__form-group">
                                        {this.state.formFields.lines.map((line, index) => {
                                            return <div className="form__form-group-field"
                                                        style={{flexDirection: "column"}}
                                                        key={index}
                                            >
                                                <Row style={{width: "100%", flexDirection: "row-reverse"}} className={"line_row"}>
                                                    {(!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin)) &&
                                                    <Col>
                                                        <div>
                                                        <span
                                                            className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.givenNumberQuestion}</span>
                                                            <div className='form__form-group-field'>
                                                                <Select
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        backgroundColor: '#F0F8FF',
                                                                        width: '220px'
                                                                    }}
                                                                    name='select'
                                                                    value={line.question}
                                                                    type={"select"}
                                                                    select
                                                                    options={transferQuestionOptions}
                                                                    onChange={(value) => this.linesChanged("update", index, "question", value.value)}>
                                                                </Select>

                                                            </div>
                                                        </div>
                                                    </Col>}

                                                    {isNew &&
                                                    <Col>
                                                        <div>
                                                            <span className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.givenNumberQuestionOnAdd}</span>
                                                            <div className='form__form-group-field'>
                                                                <Select
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        backgroundColor: '#F0F8FF',
                                                                        width: '220px'
                                                                    }}
                                                                    name='select'
                                                                    value={line.question}
                                                                    type={"select"}
                                                                    select
                                                                    options={transferQuestionOptionsOnAdd}
                                                                    onChange={(value) => this.linesChanged("update", index, "question", value.value)}>
                                                                </Select>
                                                            </div>
                                                        </div>
                                                    </Col>}

                                                    {line.question === 1 && <Col>
                                                        <div>
                                                            <span className="form__form-group-label">
                                                                {TextManager.getCurrentTextResource().Sales.salesItem.customerNumber}
                                                            </span>
                                                            <input
                                                                value={line.customerNumber}
                                                                style={{backgroundColor: '#F0F8FF', width: '220px'}}
                                                                name="customerNumber"
                                                                dir={"auto"}
                                                                type="text"
                                                                onChange={(event) =>
                                                                    this.linesChanged("update", index, "customerNumber", event.target.value)}
                                                            />
                                                        </div>
                                                    </Col>}

                                                    {line.question === 0 && <Col>
                                                        <div>
                                                            <span className="form__form-group-label">
                                                                {TextManager.getCurrentTextResource().Sales.salesItem.customerNumber}
                                                            </span>
                                                            <input
                                                                value={"חדש"}
                                                                name="customerNumber"
                                                                dir={"auto"}
                                                                disabled={true}
                                                                type="text"
                                                                style={{
                                                                    backgroundColor: '#DCDCDC',
                                                                    width: '150px'
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>}
                                                    <Col>
                                                        <div>
                                                        <span className="form__form-group-label">
                                                            {TextManager.getCurrentTextResource().Sales.salesItem.simNumber}
                                                        </span>
                                                            <input
                                                                value={line.simNumber}
                                                                dir={"auto"}
                                                                style={{backgroundColor: '#F0F8FF', width: '220px'}}
                                                                name="simNumber"
                                                                type="text"
                                                                onChange={(event) =>
                                                                    this.linesChanged("update", index, "simNumber", event.target.value)}/>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div>
                                                        <span
                                                            className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.deal}</span>
                                                            <div className='form__form-group-field'>
                                                                {(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin))) &&
                                                                <Select
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        backgroundColor: '#F0F8FF',
                                                                        width: '220px'
                                                                    }}
                                                                    name='select'
                                                                    value={line.deal.text}
                                                                    type={"select"}
                                                                    select
                                                                    options={this.props.dealsList.map(d => {
                                                                        return {
                                                                            label: d.text,
                                                                            value: d.text,
                                                                            amount: d.amount
                                                                        }
                                                                    })}
                                                                    onChange={(value) => this.dealChanged(index, value)}>
                                                                </Select>}

                                                                {!isNew && !this.props.userData.data.isManager && !this.props.userData.data.isAdmin &&
                                                                <input
                                                                    value={line.deal.text}
                                                                    dir={"auto"}
                                                                    name="amount"
                                                                    type="text"
                                                                    disabled={true}
                                                                    style={{
                                                                        backgroundColor: '#DCDCDC',
                                                                        width: '120px'
                                                                    }}/>
                                                                }
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div>
                                                            <span
                                                                className='form__form-group-label'>{TextManager.getCurrentTextResource().Text.price}
                                                            </span>
                                                            <div className='form__form-group-field'>
                                                                <input
                                                                    value={line.deal.amount}
                                                                    dir={"auto"}
                                                                    name="amount"
                                                                    type="text"
                                                                    disabled={true}
                                                                    style={{
                                                                        backgroundColor: '#DCDCDC',
                                                                        width: '120px'
                                                                    }}/>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    {isNew && index > 0 && <Col style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "flex-end"
                                                    }}>
                                                        <div style={{padding: "20px 10px"}}>
                                                            <i className="fas fa-trash" style={{cursor: 'pointer'}}
                                                               onClick={
                                                                   (event) =>
                                                                       this.linesChanged("delete", index)
                                                               }> </i>
                                                        </div>
                                                    </Col>
                                                    }

                                                    {!isNew && <Col>
                                                        <div>
                                                            <span
                                                                className='form__form-group-label'>{TextManager.getCurrentTextResource().Customers.status}
                                                            </span>
                                                            <div className='form__form-group-field'>
                                                                <Button color={line.status === 1 ? "success" : "danger"}
                                                                        size='sm'
                                                                        onClick={() => this.changeLineStatus('status', index)}>{line.status === 1 ? TextManager.getCurrentTextResource().Customers.active :
                                                                    TextManager.getCurrentTextResource().Customers.notActive}</Button>
                                                            </div>
                                                        </div>
                                                    </Col>}

                                                    {isNew && <Col></Col>}

                                                    {!isNew && <Col>
                                                        <div>
                                                            <span
                                                                className='form__form-group-label'>{TextManager.getCurrentTextResource().Customers.temp}
                                                            </span>
                                                            <div className='form__form-group-field'>
                                                                <Button
                                                                    color={line.secondStatus === 1 ? "success" : "danger"}
                                                                    size='sm'
                                                                    onClick={() => this.changeLineStatus('secondStatus', index)}>{line.secondStatus === 1 ? TextManager.getCurrentTextResource().Customers.yes :
                                                                    TextManager.getCurrentTextResource().Customers.no}</Button>
                                                            </div>
                                                        </div>
                                                    </Col>}

                                                    {isNew && <Col></Col>}

                                                    {!isNew && <Col>
                                                        <div>
                                                            <span className="form__form-group-label">
                                                                {TextManager.getCurrentTextResource().Customers.notes}
                                                            </span>
                                                            <input
                                                                value={line.notes}
                                                                style={{backgroundColor: '#F0F8FF'}}
                                                                name="customerNumber"
                                                                dir={"auto"}
                                                                type="text"
                                                                onChange={(event) =>
                                                                    this.linesChanged("update", index, "notes", event.target.value)}
                                                            />
                                                        </div>
                                                    </Col>}

                                                    {isNew && <Col></Col>}

                                                    {!isNew && index > 0 && <Col style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "flex-end"
                                                    }}>
                                                        <div style={{padding: "20px 10px"}}>
                                                            <i className="fas fa-trash" style={{cursor: 'pointer'}}
                                                               onClick={
                                                                   (event) =>
                                                                       this.linesChanged("delete", index)
                                                               }> </i>
                                                        </div>
                                                    </Col>
                                                    }

                                                    {!isNew && index === 0 && <Col style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "flex-end"
                                                    }}>

                                                    </Col>
                                                    }
                                                </Row>
                                                {/*index === this.state.formFields.lines.length - 1 &&
                                                <Row style={{width: "100%", flexDirection: "row-reverse"}}>
                                                    <Col>

                                                    </Col>
                                                    <Col>

                                                    </Col>
                                                    <Col>

                                                    </Col>
                                                    <Col>
                                                        <div style={isNew ? {marginRight: '220px'} : {marginRight: '300px'}}>
                                                            <span className='form__form-group-label'>{TextManager.getCurrentTextResource().Text.price}</span>
                                                            <div className='form__form-group-field'>
                                                                <input
                                                                    dir={"auto"}
                                                                    value={totalPrice}
                                                                    name="amount"
                                                                    type="text"
                                                                    style={{backgroundColor: '#DCDCDC', width: '80px'}}
                                                                    disabled={true}/>
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col>

                                                    </Col>

                                                    <Col>

                                                    </Col>

                                                    <Col>

                                                    </Col>

                                                    <Col>

                                                    </Col>
                                                </Row>*/}
                                            </div>
                                        })}
                                        {isNew && <div style={{textAlign: 'right', marginTop: '10px'}}>
                                            <Button color="primary"
                                                    onClick={this.addLine}>{TextManager.getCurrentTextResource().Sales.salesItem.addLine}</Button>
                                        </div>
                                        }
                                    </div>

                                    <div className="form__form-group">
                                        <span
                                            className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.paymentMethod}</span>
                                        <div className={"radio-button__group"}>
                                            <RadioButtonField name="credit" value={"credit"}
                                                              label={TextManager.getCurrentTextResource().Sales.salesItem.creditCard}
                                                              onChange={(value) => {
                                                                  this.formFieldValueChanged('paymentMethod', 'credit');
                                                                  // this.paymentDetailsChanged('cardType', 'mc');
                                                              }}
                                                              radioValue={this.state.formFields.paymentMethod}/>
                                            <RadioButtonField name="bank" value={"bank"}
                                                              onChange={(value) => {
                                                                  this.formFieldValueChanged('paymentMethod', 'bank');

                                                              }}
                                                              label={TextManager.getCurrentTextResource().Sales.salesItem.directDebit}
                                                              radioValue={this.state.formFields.paymentMethod}/>
                                        </div>

                                    </div>

                                    {this.state.formFields.paymentMethod === "credit" &&
                                    <div className="form__form-group">
                                        <Row style={{flexDirection: 'row-reverse'}}>

                                            <Col sm={4}>
                                                <span
                                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.cardNumber}</span>
                                                <div className="form__form-group-field">
                                                    <NumberFormat
                                                        //format="#### #### #### ####"
                                                        format="################"
                                                        style={{backgroundColor: '#F0F8FF'}}
                                                        value={this.state.formFields.paymentDetails.cardNumber || ''}
                                                        name="cardNumber"
                                                        onFocus={() => this.cardFocusChanged("cardNumber")}
                                                        placeholder="0000 0000 0000 0000"
                                                        type="text"
                                                        onChange={(event) => {
                                                            this.paymentDetailsChanged('cardNumber', event.target.value);
                                                        }

                                                        }
                                                    />
                                                </div>
                                                <span
                                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.validationDate}</span>
                                                <div className="form__form-group-field">
                                                    <NumberFormat
                                                        format={this.cardExpiry}
                                                        style={{backgroundColor: '#F0F8FF'}}
                                                        value={this.state.formFields.paymentDetails.validationDate || ""}
                                                        name="validationDate"
                                                        required
                                                        onFocus={() => this.cardFocusChanged("validationDate")}
                                                        placeholder="MM/YY"
                                                        data-valid-example="05/18"
                                                        onChange={(event) =>
                                                            this.paymentDetailsChanged('validationDate', event.target.value)}
                                                    />
                                                </div>
                                                <span
                                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.cvv}</span>
                                                <div className="form__form-group-field">
                                                    <input
                                                        dir={"auto"}
                                                        value={this.state.formFields.paymentDetails.cvv || ''}
                                                        style={{backgroundColor: '#F0F8FF'}}
                                                        name="cvv"
                                                        minLength={(this.state.formFields.paymentDetails.cardType === "mastercard"
                                                            || this.state.formFields.paymentDetails.cardType === "visa") ? 3 : 4}
                                                        maxLength={this.state.formFields.paymentDetails.cardType === "mastercard"
                                                        || this.state.formFields.paymentDetails.cardType === "visa" ? 3 : 4}
                                                        type="text"
                                                        autoComplete={"on"}
                                                        required
                                                        onFocus={() => this.cardFocusChanged("cvv")}
                                                        onChange={(event) =>
                                                            this.paymentDetailsChanged('cvv', event.target.value)}
                                                    />
                                                </div>
                                            </Col>

                                            <Col sm={3}>
                                                <div className="form__form-group-field">
                                                    <Cards style={{margin: 'none'}}
                                                           preview={true}
                                                           number={this.state.formFields.paymentDetails.cardNumber}
                                                           name={""}
                                                           expiry={this.state.formFields.paymentDetails.validationDate || ""}
                                                           cvc={this.state.formFields.paymentDetails.cvv}
                                                           focused={this.state.cardFocus}
                                                           placeholders={{
                                                               name: ''
                                                           }}
                                                           callback={(event, isValid) =>
                                                               this.paymentDetailsChanged('cardType', event.issuer)}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    }


                                    {this.state.formFields.paymentMethod === "bank" &&
                                    <div className="form__form-group">
                                        <span
                                            className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.bank}</span>
                                        <div className="form__form-group-field">
                                            <input
                                                dir={"auto"}

                                                value={this.state.formFields.paymentDetails.bank}
                                                name="bank"
                                                type="text"
                                                onChange={(event) =>
                                                    this.paymentDetailsChanged('bank', event.target.value)}
                                            />
                                        </div>

                                        <span
                                            className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.bankAccountBranch}</span>
                                        <div className="form__form-group-field">
                                            <input
                                                dir={"auto"}

                                                value={this.state.formFields.paymentDetails.bankAccountBranch}
                                                name="bank"
                                                type="text"
                                                onChange={(event) =>
                                                    this.paymentDetailsChanged('bankAccountBranch', event.target.value)}
                                            />
                                        </div>

                                        <span
                                            className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.bankAccountNumber}</span>
                                        <div className="form__form-group-field">
                                            <input
                                                dir={"auto"}
                                                value={this.state.formFields.paymentDetails.bankAccountNumber}
                                                name="bank"
                                                type="text"
                                                onChange={(event) =>
                                                    this.paymentDetailsChanged('bankAccountNumber', event.target.value)}
                                            />
                                        </div>

                                    </div>
                                    }


                                    <div className="form__form-group">
                                        <Row style={{flexDirection: 'row-reverse'}}>
                                            <Col sm={6}>
                                                <div className="form__form-group" dir="rtl">
                                                    <span className="form__form-group-label"
                                                          style={{fontWeight: 'bold'}}>{TextManager.getCurrentTextResource().Sales.salesItem.commentsStore}</span>
                                                    <div>
                                                        <textarea
                                                            style={{backgroundColor: '#F0F8FF'}}
                                                            value={this.state.formFields.commentsStore}
                                                            name="commentsStore"
                                                            onChange={(event) =>
                                                                this.formFieldValueChanged('commentsStore', event.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                            </Col>
                                            <Col sm={6}>
                                                <span className="form__form-group-label"
                                                      style={{fontWeight: 'bold'}}>{TextManager.getCurrentTextResource().Sales.salesItem.commentsManager}</span>
                                                <div dir="rtl">
                                                    <textarea
                                                        value={this.state.formFields.commentsManager}
                                                        style={{backgroundColor: '#F0F8FF'}}
                                                        name="commentsManager"
                                                        onChange={(event) =>
                                                            this.formFieldValueChanged('commentsManager', event.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>


                                    <ButtonToolbar className="form__button-toolbar">
                                        <Button color="primary"
                                                onClick={this.saveCustomer}>{isNew ? TextManager.getCurrentTextResource().Sales.salesItem.send : TextManager.getCurrentTextResource().Sales.salesItem.update}</Button>
                                        {this.props.onClose && <Button type="button" onClick={this.props.onClose}>
                                            {TextManager.getCurrentTextResource().Text.cancel}
                                        </Button>}

                                        {!this.props.onClose &&
                                        <Button type="button" onClick={() => this.setState({saved: true})}>
                                            {TextManager.getCurrentTextResource().Text.cancel}

                                        </Button>}
                                    </ButtonToolbar>
                                </form>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>}

            </Container>
        )


    }

}


const mapStateToProps = (state) => {
    return {
        dealsList: state.salesItem.dealsList,
        status: state.salesItem.status,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(InternetSalesItem))